var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-data-box"},[_c('img',{staticClass:"no-data",attrs:{"src":require("../../../assets/imgs/work-wx/common/icon-no-data.png"),"alt":""}}),_c('div',{staticClass:"no-data-text"},[_vm._v(_vm._s(_vm.emptyText ? _vm.emptyText : '暂无数据'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }